import React from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import './FloatingCart.css';

const FloatingCart = ({ itemCount, onClick }) => {
  return (
    <button className="floating-cart-btn" onClick={onClick} aria-label="Shopping Cart">
      <span className="cart-icon" aria-hidden>
        <FaShoppingCart />
      </span>
      {itemCount > 0 && (
        <span className="cart-badge-floating">{itemCount}</span>
      )}
    </button>
  );
};

export default FloatingCart;

